<template>
  <p>{{ humanize }}</p>
</template>

<script>
import { format } from "date-fns"
/**
 * A cell renderer for ag-grid to render dates with times
 */
export default {
  name: "DateTimeCellRenderer",
  computed: {
    humanize() {
      if (this.params.value !== null) {
        return format(new Date(this.params.value), "M-d-yyyy, h:mm a")
      } else {
        return ""
      }
    },
  },
}
</script>
